import * as React from 'react'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import '../styles/Modal.scss'
import { Button, InputAdornment, TextField } from '@mui/material'
import GooglePlacesAutocomplete, {
  geocodeByPlaceId,
  getLatLng,
} from 'react-google-places-autocomplete'
import { Circle, GoogleMap, Marker } from '@react-google-maps/api'
import { saveOrUpdateDataById } from '../apis/generalApis'
import Swal from 'sweetalert2'
import AddSkillRateIcon from '../assets/imgs/add-skill-rate-image.svg'
import RemoveSkillRateIcon from '../assets/imgs/remove-skill-rate-image.svg'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  outline: 'none',
  maxHeight: '90vh',
  minHeight: '70vh',
  overflow: 'auto',
  background: '#fff',
  boxShadow: '0px 5px 20px #00000040',
  p: 4,
  borderRadius: '16px',
  textAlign: 'center',
}

const containerStyle = {
  width: '100%',
  height: '540px',
}

const SelectWorkAreaModal = ({
  handleSelectWorkAreaModal,
  selectWorkAreaModal,
}) => {
  const user = JSON.parse(localStorage.getItem('user'))
  const client_location = JSON.parse(localStorage.getItem('client_location'))
  const [center, setCenter] = React.useState(
    client_location ?? {
      lat: 48.8584,
      lng: 2.2945,
    },
  )
  const [radius, setRadius] = React.useState(0)
  const [mapCenter, setMapCenter] = React.useState({
    ...center,
  })
  const memoizedCenter = React.useMemo(() => setMapCenter(center), [center])
  const [value, setValue] = React.useState(null)
  React.useEffect(() => {
    if (value?.value?.place_id) {
      geocodeByPlaceId(value?.value?.place_id)
        .then((results) => {
          const latLng = getLatLng(results[0])
            .then((coordinates) => {
              setCenter(coordinates)
            })
            .catch((err) => console.log(err))
        })
        .catch((error) => console.error(error))
    }
  }, [value])

  const handleUpdateWOrkingArea = async () => {
    const body = {
      user_id: user?.id,
      latitude: center?.lat,
      longitude: center?.lng,
      radius,
    }
    const result = await saveOrUpdateDataById('update-working-area', body)
    if (result?.success === true) {
      handleSelectWorkAreaModal(false)
      Swal.fire({
        title: 'Working Area Updated Successfully!',
        icon: 'success',
        confirmButtonColor: '#2597F6',
        timer: 3000,
      })
    }
  }

  // console.log(center)

  return (
    <>
      <Modal
        open={selectWorkAreaModal}
        onClose={() => handleSelectWorkAreaModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="work-area-modal-box">
          <div className="text-center">
            <h3 className="fs-24 fw-bold pb-2">Select Work Area</h3>
            <div className="autoplaces-container mb-4">
              <GooglePlacesAutocomplete
                selectProps={{
                  value,
                  onChange: setValue,
                  styles: {
                    control: (base, state) => ({
                      ...base,
                      border: '1px solid #08c4bb',
                      borderRadius: '8px !important',
                      // This line disable the blue border
                      boxShadow: state.isFocused ? 0 : 0,
                      '&:hover': {
                        border: '1px solid #08c4bb',
                        borderRadius: '8px !important',
                      },
                    }),
                    input: (provided) => ({
                      ...provided,
                      borderRadius: '8px !important',
                    }),
                    container: (provided) => ({
                      ...provided,
                      // border: '1px solid #08c4bb',
                      borderRadius: '8px !important',
                    }),
                  },
                }}
              ></GooglePlacesAutocomplete>
            </div>
            <div className="d-flex align-items-center mb-4 mx-3">
              <p className="fs-16 w-50 font-weight-bold">Radius (miles)</p>
              <TextField
                id="outlined-adornment-amount"
                placeholder="40"
                type={'number'}
                className="w-50 radius-input"
                required
                value={radius}
                onChange={(e) => {
                  if (e.target.value > 0) {
                    setRadius(+e.target.value)
                  }
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <img
                        src={AddSkillRateIcon}
                        alt={''}
                        className="p-0 pointer"
                        height={81}
                        onClick={(e) => {
                          setRadius((prev) => +prev + 1)
                        }}
                      />
                      {/* <Button
                        className="pointer"
                        id="btn-primary-no-shadow"
                        disableElevation
                        style={{ fontSize: '2rem' }}
                      >
                        +
                      </Button> */}
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <img
                        src={RemoveSkillRateIcon}
                        alt={''}
                        className="p-0 pointer"
                        height={81}
                        onClick={(e) => {
                          setRadius((prev) => {
                            if (prev > 0) {
                              return +prev - 1
                            } else {
                              return +prev
                            }
                          })
                        }}
                      />
                      {/* <Button
                        className="pointer"
                        id="btn-primary-no-shadow"
                        disableElevation
                        style={{ fontSize: '2rem' }}
                        onClick={(e) => {
                          setRadius((prev) => {
                            if (prev > 0) {
                              return prev - 1
                            } else {
                              return prev
                            }
                          })
                        }}
                      >
                        -
                      </Button> */}
                    </InputAdornment>
                  ),
                }}
                variant="outlined"
              />
            </div>
            <div className="map-area position-relative">
              <GoogleMap
                mapContainerStyle={containerStyle}
                center={mapCenter}
                zoom={10}
                options={{
                  fullscreenControl: false,
                  streetViewControl: false,
                  mapTypeControl: false,
                  zoomControl: false,
                }}
              >
                <Marker
                  position={mapCenter}
                  opacity={1}
                  visible={true}
                  zIndex={99999}
                ></Marker>
                <Circle
                  onClick={(event) => {
                    // console.log('click', event)
                  }}
                  center={mapCenter}
                  radius={10000}
                  options={{
                    strokeColor: '#14b1e4',
                    fillColor: '#14b1e4',
                    fillOpacity: 0.5,
                    strokeOpacity: 0.5,
                  }}
                />
              </GoogleMap>
              <Button
                disableElevation
                id="btn-primary-no-shadow"
                className="pointer"
                fullWidth
                style={{
                  position: 'absolute',
                  width: '90%',
                  left: '0',
                  bottom: '3%',
                  right: '0',
                  margin: 'auto',
                }}
                onClick={handleUpdateWOrkingArea}
              >
                Confirm
              </Button>
            </div>
          </div>
        </Box>
      </Modal>
    </>
  )
}

export default SelectWorkAreaModal
